import { Schema, SchemaGetter } from "effect";

/** Encode booking defects without private request values or exception causes.
 * @since 1.1.8
 * @example Schema.encodeSync(BookingDefectSchema)(new Error("private content"));
 */
export const BookingDefectSchema = Schema.String.pipe(Schema.decodeTo(Schema.Unknown, {
  decode: SchemaGetter.transform((message) => message),
  encode: SchemaGetter.succeed("Booking request failed"),
}));

/** Scheduling transport error.
 * @since 1.1.8
 * @example NotFoundErrorSchema;
 */
export const NotFoundErrorSchema = Schema.TaggedStruct("NotFoundError", {
  message: Schema.String,
  resource: Schema.String,
  id: Schema.optional(Schema.String),
});

/** Scheduling transport error.
 * @since 1.1.8
 * @example ExternalAPIErrorSchema;
 */
export const ExternalAPIErrorSchema = Schema.TaggedStruct("ExternalAPIError", {
  message: Schema.String,
  statusCode: Schema.optional(Schema.Number),
  cause: Schema.optional(Schema.Unknown),
});

/** Scheduling transport error.
 * @since 1.1.8
 * @example ConsultTimesNotFoundErrorSchema;
 */
export const ConsultTimesNotFoundErrorSchema = Schema.TaggedStruct(
  "ConsultTimesNotFoundError",
  {
    message: Schema.String,
    calendarId: Schema.String,
  },
);
